import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Apps from './components/Apps';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import JustPDFPrivacyPolicy from './components/JustPDFPrivacyPolicy';
import JustConverterPrivacyPolicy from './components/JustConverterPrivacyPolicy';
import JustSaverPrivacyPolicy from './components/JustSaverPrivacyPolicy';
import JustPrintPrivacyPolicy from './components/JustPrintPrivacyPolicy';
import JustSolarPrivacyPolicy from './components/JustSolarPrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import RefundPolicy from './components/RefundPolicy';
import ContactUsPage from './components/ContactUsPage';
import JustSolar from './components/JustSolar';
import DataDeletion from './components/DataDeletion';
import { useScrollAnimation } from './hooks/useScrollAnimation';
import './App.css';

const Home = () => (
  <main>
    <Hero />
    <About />
    <Apps />
    <Services />
    <Contact />
  </main>
);

function App() {
  // Initialize scroll animations
  useScrollAnimation();

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index.html" element={<Home />} />

          {/* Dedicated JustSolar Product Page */}
          <Route path="/justsolar" element={<JustSolar />} />

          {/* Compliance & Legal Routes */}
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/refund-cancellation-policy" element={<RefundPolicy />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route path="/data-deletion-request" element={<DataDeletion />} />

          {/* App-Specific Privacy Policies */}
          <Route path="/justsolar_privacypolicy" element={<JustSolarPrivacyPolicy />} />
          <Route path="/justpdf_privacypolicy" element={<JustPDFPrivacyPolicy />} />
          <Route path="/justconverter_privacy_policy" element={<JustConverterPrivacyPolicy />} />
          <Route path="/just-saver_privacypolicy" element={<JustSaverPrivacyPolicy />} />
          <Route path="/justsaver_privacypolicy" element={<JustSaverPrivacyPolicy />} />
          <Route path="/justprint_privacypolicy" element={<JustPrintPrivacyPolicy />} />

          {/* Fallback route to prevent blank page on file opening or unmatched paths */}
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
